export default __webpack_public_path__ + "b903b9c7391697c42b54cf19d49891ef.png";